module.exports = __webpack_public_path__ + "img/one-line-vehicle-row-cjdr.de9115d6.png";